import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const ProtectedSchoolForm = ({ Component, user }) => {
  // const { loading, user, isAuthenticated } = useSelector((state) => state.LoadUser)
  // console.log(user)

  const navigate = useNavigate();
  // const dispatch = useDispatch();
  // useEffect(() => {
  //     dispatch(loadUser());
  // }, [dispatch]);

  useEffect(() => {
    const isAuthenticated = localStorage.getItem("reinventTokenSchoolForm");

    const Surl = localStorage.getItem("SchoolUrl");

    if (!isAuthenticated) {
      if (Surl) {
        toast.error("Please Login to excess this");

        navigate(`/${Surl}/login`);
      } else {
        toast.error("Please Login to excess this");
        navigate("/:url/login");
      }
    }
  }, [navigate]);

  return (
    <>
      <Component />
    </>
  );
};

export default ProtectedSchoolForm;
